import { Callout } from '@repo/ui/components/ui/callout'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@repo/ui/components/ui/card'
import { createFileRoute } from '@tanstack/react-router'
import { DocumentRouteShell } from '@/components/app/route-shells'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'
import { trpc } from '@/lib/trpc'

export const Route = createFileRoute('/_app/admin/emails')({
  component: AdminEmailsPage,
  staticData: {
    breadcrumbs: [{ label: 'Emails' }],
  } satisfies RouteStaticData,
})

function AdminEmailsPage() {
  const queueQuery = trpc.admin.emails.queueStatus.useQuery()
  const queue = queueQuery.data

  return (
    <DocumentRouteShell>
      {queueQuery.isError ? (
        <Callout variant="destructive">
          <p className="text-sm text-muted-foreground">
            Failed to load queue metrics. {(queueQuery.error as unknown as Error).message}
          </p>
        </Callout>
      ) : (
        <div className="grid gap-4 md:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle>Pending</CardTitle>
              <CardDescription>Queued for delivery</CardDescription>
            </CardHeader>
            <CardContent className="text-3xl font-semibold">{queue?.pending ?? 0}</CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Sent</CardTitle>
              <CardDescription>Processed successfully</CardDescription>
            </CardHeader>
            <CardContent className="text-3xl font-semibold">{queue?.sent ?? 0}</CardContent>
          </Card>
          <Card>
            <CardHeader>
              <CardTitle>Failed</CardTitle>
              <CardDescription>Require investigation</CardDescription>
            </CardHeader>
            <CardContent className="text-3xl font-semibold">{queue?.failed ?? 0}</CardContent>
          </Card>
        </div>
      )}
    </DocumentRouteShell>
  )
}
